<button class="btn-icon blue" [cdkCopyToClipboard]="content">
  <mat-icon class="icon-18">content_copy</mat-icon>
</button>
